<template>
  <KModal
    :show.sync="showModal"
    :no-close-on-backdrop="true"
    :centered="true"
    title="Washing Dialog"
    color="info"
  >
    <template #header>
      <h6 class="modal-title text-center">{{title}} 역세척</h6>
    </template>

    <div class='modal-body'>
      <CRow v-if="which!='man'">
        <CCol col="12" xl="12">
            <label><strong>{{title}}역세척 설정</strong></label>
            <CSwitch class="float-right mr-1" color="info" v-bind="oLabelTxt" :checked.sync="active" size="sm" :disabled='isEditMode == false'/>
        </CCol>
      </CRow>

      <div class="row-margin"></div>

      <CRow>
        <CCol col="12" xl="12">
          <v-table id="settingTable" :columns="columns" :data="data" :options="options"></v-table>
        </CCol>
      </CRow>
    </div>

    <template #footer>
      <CButton @click="execute()" color="info">실행</CButton>
      <CButton @click="cancel()" color="light">취소</CButton>
    </template>

    <Notify ref="notifyDialog"/>
    
  </KModal>
</template>

<script>
import loopback from '@/services/loopback';

import {
  WASHING_TABLE_OPTIOINS, WASHING_TABLE_COLUMS, WASHING_TYPE
} from "@/views/btfs/washSettings";

export default {
  name: 'WashingDialog',
  props: {
    isAdmin: Boolean
  },
  data () {
    return {
      showModal: false,
      title: '생성',
      which: 'create',
      type: 'submerged',
      device: {},
      options: WASHING_TABLE_OPTIOINS,
      columns: WASHING_TABLE_COLUMS,
      data : [],
      modified: [],
      isEditMode: true,
      active: false,
      oLabelTxt: {
        labelOn: 'ON',
        labelOff: 'OFF'
      },
    }
  },
  created() {
    _.find(this.columns, { field: 'time' }).formatter = this.timeFormatter;
    _.find(this.columns, { field: 'enable' }).formatter = this.enableFormatter;
  },
  mounted() {
    $('#settingTable').bootstrapTable('refreshOptions', {
      classes: 'table'
    })
  },
  methods: {
    timeFormatter(value, row, index) {
      var id = 'time-' + index;
      var disabled = ''
      if (this.type === 'filtered') {
        if (this.which !== 'semi')
          disabled = 'disabled="true"'
      } else {
        if (this.which === 'auto' || this.which === 'man') 
          disabled = 'disabled="true"'
      }
      // if (this.which === 'auto' || this.which === 'man')
      //      disabled = 'disabled="true"';
                 
      return '<div class="col-md-8 col-lg-8" style="float:none;margin:auto;"> \
          <input type="number" id="{0}" style="font-size:12px;" class="form-control" min="10" max="600" value="{1}" step="1" {2}/> \
          </div>'.format(id, this.which === 'man' ? "none" : value, disabled)
    },
    enableFormatter(value, row, index) {
      var disabled = ''
      if (this.type === 'filtered') {
        if (this.which === 'auto')
          disabled = 'disabled="true"'
        else if(this.which === 'semi'){
          value = true;
          disabled = 'disabled="true"'
        }
      } else {
        if (this.which === 'auto')
          disabled = 'disabled="true"'
      }
      // if (this.which === 'auto')
      //     disabled = 'disabled="true"';
      
      return '<div class="custom-switch"> \
          <input type="checkbox" class="custom-control-input" id="{0}" {1} {2}> \
          <label class="custom-control-label" for="{0}"></label> \
          </div>'.format('switch-' + index, value === true ? 'checked' : '', disabled)
    },
    execute() {
      var self = this;
      var enabled = _.filter(this.modified, {enable:true});
      var data = {
        command: 'exec',
        device_guid: this.device.guid,
        params: [{
          cmd: 'actu',
          type: self.type == 'submerged' ? 'wa' : 'fw',
          data: {
            type: this.which,
            action: !enabled.length ? this.active ? 1 : 0 : 1
          },
          site_guid: this.device.site_guid
        }]
      }
      if(this.type === 'filtered'){
        if(this.which === 'semi'){
          enabled = _.filter(this.modified, {enable:false});
          data.params[0].data.action = this.active ? 1 : 0;
        }
      }
      enabled.forEach(e => {
        data.params[0].data[e.field] = (this.which === 'man') ? 1 : e.time;//(self.type === 'submerged' && this.which === 'man') ? 1 : e.time;
      })
      this.$store.dispatch('rest/method', {model:'devices',method:'Command',data:data})
        .then(res => {
          this.showModal = false;
        })
        .catch(err => {
          console.log('WashingDialog execute error: ', err.toString())
          var message = err.toString();
          if(message == "Error: Already running command: run after a minutes"){
            message = "이미 처리중인 작업이 있습니다. 잠시만 기다려주세요.";
          }
          
          this.$refs.notifyDialog.show(message.toString())
          setTimeout(function() {
            //self.showModal = false;
          }, 3000)
        })
    },
    cancel() {
      this.showModal = false;
    },
    switchTrigger() {
      var self = this;
      this.data.forEach((el, i) => {
        var name = 'switch-' + i;
        var elem = document.getElementById(name);
        elem.addEventListener("click", function() {
          self.modified[i].enable = !self.modified[i].enable;
          var timeelem = document.getElementById('time-'+i);
          if (self.modified[i].enable && self.which === 'semi')
            timeelem.removeAttribute('disabled');
          else
            timeelem.setAttribute('disabled', 'disabled');
        }, false);
      })
    },
    timeTrigger() {
      var self = this;
      this.data.forEach((el, i) => {
        var name = 'time-' + i;
        var elem = document.getElementById(name);
        elem.addEventListener("change", function(e) {
          self.modified[i].time = e.target.value;
        }, false);
      })
    },
    show(which='auto', device) {
      var self = this
      var type = _.get(device, "service_type", "submerged"); // || submerged
      if (!_.get(WASHING_TYPE, type)) {
        console.log('WashingDialog::show error - unknown type:', type);
        return;
      }
      this.which = which
      this.type = type
      this.device = device;
      this.title = which == 'auto' ? '자동' : which == 'semi' ? '반자동' : '수동';
      this.data = _.cloneDeep(WASHING_TYPE[type]);
      this.modified = _.cloneDeep(WASHING_TYPE[type]);
      this.showModal = true
      setTimeout(function() {
        self.timeTrigger()
        self.switchTrigger()
      }, 100)
    }
  }
}
</script>

<style scoped>
.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0.50rem;
}
.row-margin {
  margin: 20px 0 20px;
}

</style>